var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 0H5C3.6225 0 2.5 1.1225 2.5 2.5V37.5C2.5 38.88 3.6225 40 5 40H35C36.38 40 37.5 38.88 37.5 37.5V2.5C37.5 1.1225 36.38 0 35 0Z",
    fill: "#455A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 20H7.5V25H12.5V20Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 20H17.5V25H22.5V20Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 30H7.5V35H12.5V30Z",
    fill: "#FAFAFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 30H17.5V35H22.5V30Z",
    fill: "#FAFAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 20H27.5V35H32.5V20Z",
    fill: "#FFC107"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 13.75C32.5 14.44 31.94 15 31.25 15H8.75C8.06 15 7.5 14.44 7.5 13.75V6.25C7.5 5.56 8.06 5 8.75 5H31.25C31.94 5 32.5 5.56 32.5 6.25V13.75Z",
    fill: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.75d726454af5fe0135fc1dd141673b9b.svg";
export { ForwardRef as ReactComponent };